import React from 'react'
import { useTranslation } from 'react-i18next'

import { getTranslate } from 'helpers/translate'
import ServerImage from 'components/ServerImage'
import CustomTitleComponent from './CustomTitleComponent'

interface Props {
  provider: Provider
  benefit: Benefit
}

const ProviderInfo = (prop: Props) => {
  const { i18n } = useTranslation()
    const{ provider, benefit } = prop

  return (
    <React.Fragment>
      <div
          style={{
              backgroundImage: `url('/img/savings-bg.png')`, // o 'Ahorro%203.jpg'
              backgroundSize: 'contain',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              height: '230px',
              borderRadius: '1rem',
              boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
              overflow: 'hidden',
              backdropFilter: 'blur(3px)',
              transition: 'transform 0.3s ease',
          }}
        className="embed-img featured-image w-100"
      />
      <div className="image-card">
        {provider && provider.logo && (
          <div className="image">
            <ServerImage src={provider.logo} />
          </div>
        )}
        <div className="card-benefit">
            <CustomTitleComponent
                provider={provider}
                benefit={benefit}
            />
            <div className="my-3">
            {benefit &&
              getTranslate(benefit.product, 'description', i18n.language)}
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default ProviderInfo